var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.44385C6.74414 2.44385 4.5 4.68799 4.5 7.44385C4.5 8.64111 4.91992 9.73877 5.625 10.6001L1.64062 14.5845L2.35938 15.3032L6.34375 11.3188C7.20508 12.0239 8.30273 12.4438 9.5 12.4438C12.2559 12.4438 14.5 10.1997 14.5 7.44385C14.5 4.68799 12.2559 2.44385 9.5 2.44385ZM9.5 3.44385C11.7148 3.44385 13.5 5.229 13.5 7.44385C13.5 9.65869 11.7148 11.4438 9.5 11.4438C7.28516 11.4438 5.5 9.65869 5.5 7.44385C5.5 5.229 7.28516 3.44385 9.5 3.44385Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.8ecd8b079be2dadf2379f98182721d78.svg";
export { ForwardRef as ReactComponent };